export default __webpack_public_path__ + "static/media/global-icon-four-hover.b8d6c06f.svg";